export default "__VITE_ASSET__fdadcc09__"